export default {
  stores: null,
  store: null,
  error: false,
  success: false,
  errorMessage: "",
  successMessage: "",
};
